import React from "react";
import Moment from "react-moment";
import { withRouter } from "react-router-dom";

import { Grid, Typography, IconButton } from "@material-ui/core";

import useStyles from "./styles";

const CardFooter = ({ history, actions, info }) => {
  const { campaign_subscriptions, catchPrase, interests, created_at } = info;

  const {
    cFooter,
    cActions,
    cAction,
    cActionSize,
    cFooterText,
    cInterest,
    cCreatedAt,
    cFooterItemContainer
  } = useStyles();

  return (
    <Grid item container className={cFooter}>
      <Grid item container className={cActions}>
        {actions.map(({ title, action, icon }, i) => (
          <IconButton
            key={i}
            size="small"
            aria-label={title}
            classes={{ sizeSmall: cActionSize }}
            className={cAction}
            onClick={action}
          >
            {icon}
          </IconButton>
        ))}
      </Grid>

      <Grid item className={cFooterItemContainer}>
        {
          <Typography className={cFooterText}>
            <strong>{campaign_subscriptions.length}</strong> se han suscrito a
            ésta campaña.
          </Typography>
        }
        <Typography className={cFooterText}>{catchPrase}</Typography>
      </Grid>

      <Grid item className={cFooterItemContainer}>
        <Typography className={cInterest}>
          {interests.map(e => (
            <strong
              key={e.id}
              onClick={() => history.push(`/campaigns/interest/${e.id}`)}
            >
              #{e.name}{" "}
            </strong>
          ))}
        </Typography>
      </Grid>

      <Grid item className={cCreatedAt}>
        <Typography className={cCreatedAt}>
          creada hace{" "}
          <Moment fromNow ago>
            {created_at}
          </Moment>
        </Typography>
      </Grid>
    </Grid>
  );
};

export default withRouter(CardFooter);
